<template>
  <div
    class="va-file-upload-list"
    :class="`va-file-upload-list--${type}`"
  >
    <template v-if="type === 'list'">
        <va-file-upload-list-item
          v-for="(file, index) in filesList"
          :key="file.name+'_'+index"
          :file="file"
          :color="color"
          @remove="$emit('remove', index)"
        />
    
    </template>
    <template v-if="type === 'gallery'">
      <draggable class="draggable" v-model="filesList">
        <va-file-upload-gallery-item
          v-for="(file, index) in filesList"
          :file="file"
          :key="file.name+'_'+index"
          :color="color"
          @remove="$emit('remove', file.uuid)"
        />
      </draggable>
    </template>
    <va-file-upload-single-item
      v-if="type === 'single' && filesList.length"
      :file="filesList[filesList.length - 1]"
      @remove="$emit('remove-single')"
    />
  </div>
</template>

<script>
import VaFileUploadListItem from './VaFileUploadListItem'
import VaFileUploadGalleryItem from './VaFileUploadGalleryItem'
import VaFileUploadSingleItem from './VaFileUploadSingleItem'
import draggable from 'vuedraggable'

export default {
  name: 'va-file-upload-list',
  components: {
    VaFileUploadListItem,
    VaFileUploadGalleryItem,
    VaFileUploadSingleItem,
    draggable
  },
  props: {
    type: {
      type: String,
    },
    files: {
      default: null,
    },
    color: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    filesList: {
        get() {
            return this.files.map(this.convertFile)
        },
        set(value) {
            var arr = [];
            for(var i in value){
              var obj = {};
              obj.uuid = value[i].uuid;
              obj.file = value[i].image;
              obj.order = i;
              arr.push(obj)
            }
            this.$emit('reorderList',arr);
        }
    }
  },
  methods: {
    convertFile (file) {
      return {
        name: file.file.name || file.file.url,
        size: file.file.size ? this.formatSize(file.size) : '',
        date: this.formatDate(new Date()),
        image: file.file,
        uuid: file.uuid
      }
    },
    formatSize (bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    formatDate (date) {
      if (!date) return ''
      return date.toLocaleDateString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    },
  },
}
</script>

<style lang='scss'>
.va-file-upload-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 1.5rem;

  &--gallery {
    padding-bottom: .5rem;
  }
  .draggable{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
